export const initialFieldValues = {
  email: '',
  password: '',
};
